"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.videoEmbedOverlayProps = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dompurify = require("dompurify");

var _Button = _interopRequireDefault(require("../Button"));

var _LivePlayer = require("./LivePlayer.style");

function VideoOverlay(_ref) {
  var button = _ref.button,
      title = _ref.title,
      sponsorLogo = _ref.sponsorLogo;

  function handleClick(e, label, trackUrl) {
    if (button && typeof button.handleClick === 'function') {
      e.preventDefault();
      button.handleClick(e, label, trackUrl);
    }
  }

  return /*#__PURE__*/_react.default.createElement(_LivePlayer.VideoOverlayContainer, null, sponsorLogo && /*#__PURE__*/_react.default.createElement("img", {
    src: sponsorLogo,
    alt: "Sponsor Logo"
  }), button && button.text && /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: button.variant,
    onClick: function onClick(e) {
      return handleClick(e, button.text, '#');
    },
    url: button.link
  }, button.text), title &&
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  _react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (0, _dompurify.sanitize)(title)
    }
  }));
}

var videoEmbedOverlayProps = {
  button: _propTypes.default.shape({
    handleClick: _propTypes.default.func,
    link: _propTypes.default.string,
    text: _propTypes.default.string,
    variant: _propTypes.default.string
  }),
  title: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.node, _propTypes.default.string]),
  sponsorLogo: _propTypes.default.string
};
exports.videoEmbedOverlayProps = videoEmbedOverlayProps;
VideoOverlay.propTypes = _objectSpread({}, videoEmbedOverlayProps);
VideoOverlay.defaultProps = {};
var _default = VideoOverlay;
exports.default = _default;